import { ExaminationSessionListComponent } from './pages/examination-session/examination-session-list/examination-session-list.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { ManageInitialDataResolver } from './manage.resolvers';
import { NoAuthFuseGuard } from '../../../shared/src/lib/guard/noAuthFuse.guard'
import { AuthFuseGuard } from '../../../shared/src/lib/guard/authFuse.guard'

const routes: Routes = [

  { path: '', pathMatch: 'full', redirectTo: 'exercises-list' },
  { path: 'signed-in-redirect', pathMatch: 'full', redirectTo: 'exercises-list' },

  // Auth routes for guests
  {
    path: '',
    canActivate: [NoAuthFuseGuard],
    canActivateChild: [NoAuthFuseGuard],
    component: LayoutComponent,
    data: {
      layout: 'empty'
    },
    children: [
      { path: 'login', loadChildren: () => import('./pages/auth/sign-in/sign-in.module').then(m => m.AuthSignInModule) },
    ]
  },
  {
    path: '',
    canActivate: [AuthFuseGuard],
    canActivateChild: [AuthFuseGuard],
    component: LayoutComponent,
    resolve: {
      initialData: ManageInitialDataResolver,
    },
    children: [
      { path: 'exercises-list', loadChildren: () => import('./pages/exercices/excercices-list/exercises-list.module').then(m => m.ExercisesModule) },
      { path: 'exercises-form', loadChildren: () => import('./pages/exercices/excercice-form/exercise-form.module').then(m => m.ExerciseFormModule) },
      { path: 'exercises-form/:id', loadChildren: () => import('./pages/exercices/excercice-form/exercise-form.module').then(m => m.ExerciseFormModule) },
      { path: 'exercises-form/add-exercice/:variantId', loadChildren: () => import('./pages/exercices/excercice-form/exercise-form.module').then(m => m.ExerciseFormModule) },
      { path: 'examination-list', loadChildren: () => import('./pages/examination/examination-list/examination-list.module').then(m => m.ExaminationsModule) },
      { path: 'examination-form', loadChildren: () => import('./pages/examination/examination-form/examination-form.module').then(m => m.ExaminationFormModule) },
      { path: 'examination-form/:id', loadChildren: () => import('./pages/examination/examination-form/examination-form.module').then(m => m.ExaminationFormModule) },
      { path: 'examination/:exminationId/examination-variant/:id', loadChildren: () => import('./pages/examination-version/examination-variant/examination-variant.module').then(m => m.ExaminationVariantModule) },
      { path: 'examination/:exminationId/examination-variant/:variantId/add-exercice', loadChildren: () => import('./pages/examination-version/select-excercice/select-excercice.module').then(m => m.ExercisesModule) },
      { path: 'examination/:exminationId/examination-variant/:variantId/add-slide-text', loadChildren: () => import('./pages/examination-version/select-slide-text/select-slide-text.module').then(m => m.SelectSlideTextModule) },
      { path: 'examination-session-list', component: ExaminationSessionListComponent, data: { title: "Liste des sessions d'examen" } },
      { path: 'slide-text-list', loadChildren: () => import('./pages/slides-text/slide-text-list/slide-text-list.module').then(m => m.SlideTextListModule) },
      { path: 'slide-text-form', loadChildren: () => import('./pages/slides-text/slide-text-form/slide-text-form.module').then(m => m.SlideTextFormModule) },
      { path: 'slide-text-form/:id', loadChildren: () => import('./pages/slides-text/slide-text-form/slide-text-form.module').then(m => m.SlideTextFormModule) },
      { path: 'slide-text-form/add-slide/:variantId', loadChildren: () => import('./pages/slides-text/slide-text-form/slide-text-form.module').then(m => m.SlideTextFormModule) },
      { path: 'lilates', loadChildren: () => import('./pages/lilate/lilates-list/lilates-list.module').then(m => m.LilatesListModule) },
      { path: 'lilate/:id', loadChildren: () => import('./pages/lilate/lilate-detail/lilate-detail.module').then(m => m.LilateDetailModule) },
      { path: 'dashboard/lilates', loadChildren: () => import('./pages/lilate/dashboard/dashboard-lilates.module').then(m => m.DashboardLilateModule) },
      { path: 'export', loadChildren: () => import('./pages/export/export.module').then(m => m.ExportModule) },
      { path: 'partners', loadChildren: () => import('./pages/partners/partners-list/partners-list.module').then(m => m.PartnersListModule) },
      { path: 'business-list', loadChildren: () => import('./pages/business/business-list.module').then(m => m.BusinessListModule) },
      { path: 'job-list', loadChildren: () => import('./pages/job/job-list.module').then(m => m.JobListModule) },
      
      // Personas - Corporates
      { path: 'personas/corporates', loadChildren: () => import('./pages/entreprises/corporates-list/corporates-list.module').then(m => m.CorporatesListModule) },
      { path: 'personas/corporates/:id', loadChildren: () => import('./pages/entreprises/corporate-detail/corporate-detail.module').then(m => m.CorporateDetailModule) },
      
      // Personas - Companies
      { path: 'personas/companies', loadChildren: () => import('./pages/entreprises/companies-list/companies-list.module').then(m => m.CompaniesListModule) },
      { path: 'personas/companies/:id', loadChildren: () => import('./pages/entreprises/company-detail/company-detail.module').then(m => m.CompanyDetailModule) },
      
      // Personas - Group Formations
      { path: 'personas/group-formations', loadChildren: () => import('./pages/entreprises/group-formations-list/group-formations-list.module').then(m => m.GroupFormationsListModule) },
      { path: 'personas/group-formations/:id', loadChildren: () => import('./pages/entreprises/group-formation-detail/group-formation-detail.module').then(m => m.GroupFormationDetailModule) },
      
      { path: 'elates', loadChildren: () => import('./pages/elate/elates-list/elates-list.module').then(m => m.ElatesListModule) },
      { path: 'elate/:id', loadChildren: () => import('./pages/elate/elate-detail/elate-detail.module').then(m => m.ElateDetailModule) },
      { path: 'students', loadChildren: () => import('./pages/students/students-list/students-list.module').then(m => m.StudentsListModule) },
      { path: 'students/:id', loadChildren: () => import('./pages/students/student-detail/student-detail.module').then(m => m.StudentDetailModule) },
      { path: 'formations', loadChildren: () => import('./pages/formations/formations-list/formations-list.module').then(m => m.FormationsListModule) },
      { path: 'formations/:id', loadChildren: () => import('./pages/formations/formation-detail/formation-detail.module').then(m => m.FormationDetailModule) }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
